import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import axios from 'axios';
import { Col, ControlLabel, Form, Button, FormGroup, Checkbox, Modal } from 'react-bootstrap';
import config from '../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

export class CreateNewCoverNote extends Component {
  constructor(props) {
    super(props);
    const role = localStorage.getItem('role');
    const isPVCoverNote = localStorage.getItem('isPVCoverNote');
    const isCVCoverNote = localStorage.getItem('isCVCoverNote');
    let businessTypeArray = [];
    const admin = [
      { code: 'bus', name: 'Bus' },
      { code: 'fleet', name: 'Fleet' },
      { code: 'hireCar', name: 'Hire Car' },
      { code: 'motorCycle', name: 'Motor Cycle' },
      { code: 'motorTrade', name: 'Motor Trade' },
      { code: 'smartDriveCommercialVehicle', name: 'SmartDrive Commercial Vehicle' },
      { code: 'smartDrivePrivateCar', name: 'SmartDrive Private Car' },
      { code: 'specialType', name: 'Special Type' },
      { code: 'supremeMotor', name: 'SUPREME Motor' },
      { code: 'commercialVehicle', name: 'Commercial Vehicle' }
    ];
    const pv = [
      { code: 'smartDrivePrivateCar', name: 'SmartDrive Private Car' }
    ];
    const cv = [
      { code: 'smartDriveCommercialVehicle', name: 'SmartDrive Commercial Vehicle' }
    ];
    if (role === 'admin') {
      businessTypeArray = admin;
    } else {
      if (isPVCoverNote === 'true') {
        businessTypeArray = businessTypeArray.concat(pv);
      }
      if (isCVCoverNote === 'true') {
        businessTypeArray = businessTypeArray.concat(cv);
      }
    }
    this.state = {
      redirect: false,
      transactionType: '',
      businessType: '',
      checkbox: false,
      businessTypeArray,
      showModal: false,
      errorMsg: ''
    };

    this.handleChangeTransactionType = this.handleChangeTransactionType.bind(this);
    this.handleChangeBusinessType = this.handleChangeBusinessType.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
    this.close = this.close.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {},
      headers: { 'ACTION-LOG': 'Access Create New Quotation Page' }
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  close() {
    this.setState({ showModal: false });
  }

  handleChangeTransactionType(e) {
    this.setState({
      transactionType: e.target.value
    });
  }

  handleChangeBusinessType(e) {
    this.setState({
      businessType: e.target.value
    });
  }

  handleChangeCheckbox(e) {
    this.setState({
      checkbox: e.target.checked
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (!this.state.checkbox) {
      this.setState({ showModal: true, errorMsg: 'Agree the declaration first' })
      return;
    }
    const businessType = this.state.businessType;
    if (businessType === 'motorCycle' || businessType === 'smartDrivePrivateCar' ||
        businessType === 'fleet' || businessType === 'hireCar' || businessType === 'supremeMotor') {
      browserHistory.push({
        pathname: `/en${appUrlPath}/coverNotePvForm`,
        state: {
          'transactionType': this.state.transactionType,
          'businessType': this.state.businessType,
          'isAgree': this.state.checkbox
        }
      });
    } else if (businessType === 'bus' || businessType === 'motorTrade' || businessType === 'specialType' ||
        businessType === 'smartDriveCommercialVehicle' || businessType === 'commercialVehicle') {
      browserHistory.push({
        pathname: `/en${appUrlPath}/coverNoteCvForm`,
        state: {
          'transactionType': this.state.transactionType,
          'businessType': this.state.businessType,
          'isAgree': this.state.checkbox
        }
      });
    }
  }

  handleClick() {
    window.location.assign(`/en${appUrlPath}/home`);
  }

  render() {
    const downloadTnC = `${appUrlPath}/downloadTnC`;
    const downloadPersonalInformationCollection = `${appUrlPath}/downloadPersonalInformationCollection`;
    const downloadPrivacyPolicyStatement = `${appUrlPath}/downloadPrivacyPolicyStatement`;
    const downloadDeclarationCV = `${appUrlPath}/downloadDeclarationCV`;
    const downloadDeclarationPV = `${appUrlPath}/downloadDeclarationPV`;
    const downloadPolicyWordingCV = `${appUrlPath}/downloadPolicyWordingCV`;
    const downloadPolicyWordingPV = `${appUrlPath}/downloadPolicyWordingPV`;

    return (
      <div>
      {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorMsg}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
       <h2 className="ebaoUtil__HeaderTwo">New Cover Note</h2>
       <Form horizontal onSubmit={this.handleSubmit}>
          <div className="ebaoUtil__Form">
            <FormGroup controlId="transactionType">
                  <Col componentClass={ControlLabel} sm={4}>
                    Transaction Type *
                  </Col>
                  <Col sm={8}>
                    <select className="custom-select" onChange={this.handleChangeTransactionType} required>
                      <option value="">Please select</option>
                      <option value="newBusiness">New Business</option>
                      <option value="extension">Extension</option>
                      <option value="endorsement">Endorsement</option>
                      <option value="renewal">Renewal</option>
                    </select>
                  </Col>
            </FormGroup>
            <FormGroup controlId="businessType">
              <Col componentClass={ControlLabel} sm={4}>
                Business Type *
              </Col>
              <Col sm={8}>
                <select className="custom-select" onChange={this.handleChangeBusinessType} required>
                  <option value="">Please Select</option>
                  { this.state.businessTypeArray.map((obj, index) => {
                    const counter = index;
                    return (
                      <option
                        value={obj.code}
                        key={counter}
                      >{obj.name}</option>
                    );
                  }) }
                </select>
              </Col>
            </FormGroup>
            <FormGroup>
            <Col componentClass={ControlLabel} sm={1}>
            <Checkbox
              checked={this.state.checkbox}
              onClick={this.handleChangeCheckbox} />
            </Col>
              <Col sm={11}>
              By checking this box, I confirm that the proposer and/or each named driver(s) have read, understood and agreed with: (1) the declarations (<b><a target="_blank" rel="noopener noreferrer" href={downloadDeclarationPV}>Private Car</a></b> or <b><a target="_blank" rel="noopener noreferrer" href={downloadDeclarationCV}>Commercial Vehicle</a></b>, as the case may be), policy terms, conditions and exclusions (<b><a target="_blank" rel="noopener noreferrer" href={downloadPolicyWordingPV}>Private Car</a></b> or <b><a target="_blank" rel="noopener noreferrer" href={downloadPolicyWordingCV}>Commercial Vehicle</a></b>, as the case may be) , <a target="_blank" rel="noopener noreferrer" href={downloadPersonalInformationCollection}>Personal Information Collection Statement</a> as well as the <a target="_blank" rel="noopener noreferrer" href={downloadPrivacyPolicyStatement}>Privacy Policy</a>; (2) AXA will contact the proposer directly or via the intermediary as per the correspondence option selected, merely by electronic means; and (3) proposer and/or all named driver(s) meet the following criteria: a) have not been refused insurance, or have not had it terminated, or have not been refused a quotation, b) have not had their license suspended or revoked in the past 2 years, and c) with less than 12 driving offence points accumulated in the past 2 years. By checking this box, I also agree to the <a target="_blank" rel="noopener noreferrer" href={downloadTnC}>Terms and Conditions for Access to or Use of the System</a>, and that I can only issue cover notes exactly in accordance with the quotation generated by this system or issued by AXA.
              </Col>
            </FormGroup>
             <FormGroup controlId="buttonGroup">
               <div className="ebaoUtil__ButtonGroup">
                 <button type="submit" className="btn btn-axa">Submit</button>{' '}
                 <button type="button" className="btn btn-axa" onClick={this.handleClick}>Exit</button>
               </div>
             </FormGroup>
          </div>
       </Form>
    </div>
    )
  }
}

export default CreateNewCoverNote;



// WEBPACK FOOTER //
// ./src/app/pages/CreateNewCoverNote.js